import ZoneColors from '@/components/zone-colors';

// vuex
import { mapActions, mapGetters } from 'vuex';

export default {
	computed: {
		...mapGetters('options', ['indexByEnvironmentId'])
	},
	methods: {
		...mapActions('options', ['setOptionsEnvironments']),
		zoneColors(environmentId) {
			const index = this.indexByEnvironmentId(environmentId);

			if (index !== -1 && index < ZoneColors.length) {
				return `zone-${index + 1}`;
			}

			return 'zone-5';
		}
	}
};
